import React from 'react';
import axios from 'axios';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

const ChangeLabelCategotyPhaseModal = ({closeModal, type, id}) => {
    const [warning, setWarning] = React.useState('');
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [labelName, setLabelName] = React.useState('');
    const [categoryName, setCategoryName] = React.useState('');
    const [phaseName, setPhaseName] = React.useState('');
    const [phaseTime, setPhaseTime] = React.useState('');
    const [phaseTypeSch, setPhaseTypeSch] = React.useState('');

    const token = localStorage.getItem('token');
    
    React.useEffect(() => {
        if (!token) {
            handleLogout();
            return;
        }

        const fetchData = async () => {
            if (type == 'label') {
                axios.get(`/api/label?id=${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }).then(response => {
                    setLabelName(response.data.name);
    
                    setLoading(false);
                }).catch(err => {
                    console.error('Ошибка получения данных '+err);
                    setWarning('Ошибка получения данных: '+err.response.data);
                    setLoading(false);
                });
            } else if (type == 'category') {
                axios.get(`/api/category?id=${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }).then(response => {
                    setCategoryName(response.data.name);
    
                    setLoading(false);
                }).catch(err => {
                    console.error('Ошибка получения данных '+err);
                    setWarning('Ошибка получения данных: '+err.response.data);
                    setLoading(false);
                });
            } else if (type == 'phase') {
                axios.get(`/api/phase?id=${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }).then(response => {
                    setPhaseName(response.data.name);
                    setPhaseTime(response.data.time);
                    setPhaseTypeSch(response.data.typesch);
    
                    setLoading(false);
                }).catch(err => {
                    console.error('Ошибка получения данных '+err);
                    setWarning('Ошибка получения данных: '+err.response.data);
                    setLoading(false);
                });
            }
        };

        fetchData();
    }, [token, type, id]);

    const changeDataLabel = (e) => {
        e.preventDefault();

        axios.put(`/api/change-label?id=${id}&labelName=${labelName}`)
        .then(() => {
            setStatus('Данные успешно изменены.');
            window.location.reload();
        })
        .catch((err) => {
            console.error('Ошибка обновления данных: '+err);
            setStatus('Ошибка обновления данных: ' + (err.response ? err.response.data : err.message));
        })
    }
    const changeDataCategory = async (e) => {
        e.preventDefault();

        axios.put(`/api/change-category?id=${id}&categoryName=${categoryName}`)
        .then(() => {
            setStatus('Данные успешно изменены.');
            window.location.reload();
        })
        .catch((err) => {
            console.error('Ошибка обновления данных: '+err);
            setStatus('Ошибка обновления данных: ' + (err.response ? err.response.data : err.message));
        })
    }
    const changeDataPhase = async (e) => {
        e.preventDefault();

        axios.put(`/api/change-phase?id=${id}&phaseName=${phaseName}&phaseTime=${phaseTime}&phaseTypeSch=${phaseTypeSch}`)
        .then(() => {
            setStatus('Данные успешно изменены.');
            window.location.reload();
        })
        .catch((err) => {
            console.error('Ошибка обновления данных: '+err);
            setStatus('Ошибка обновления данных: ' + (err.response ? err.response.data : err.message));
        })
    }

    if (type == 'label') {

        return (
            <div className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onClick={(e) => e.stopPropagation()} onSubmit={(e) => changeDataLabel(e)}>
                    <div className={styles.header}>
                        <h1>Изменить тип дел</h1>
                        <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                        </svg>
                    </div>
                    <div className={styles.main}>
                        {loading ? (
                            <Loading />
                        ) : warning ? (
                            <a>{warning}</a>
                        ) : (
                            <span style={{width: '320px', margin: '0 auto'}}>
                                <a style={{display: 'flex', justifyContent: 'center'}}>Измените название типа дел</a>
                                <input type="text" placeholder='Введите новое название типа дел' value={labelName} onChange={(e) => {setLabelName(e.target.value)}} />
                                {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                                <button className='button maxWidth' type='submit'>Подтвердить изменение</button>
                            </span>
                        )}
                    </div>
                </form>
            </div>
        )
    }
    if (type == 'category') {
        return (
            <div className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onClick={(e) => e.stopPropagation()} onSubmit={(e) => changeDataCategory(e)}>
                    <div className={styles.header}>
                        <h1>Изменить категорию</h1>
                        <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                        </svg>
                    </div>
                    <div className={styles.main}>
                        {loading ? (
                            <Loading />
                        ) : warning ? (
                            <a>{warning}</a>
                        ) : (
                            <span style={{width: '320px', margin: '0 auto'}}>
                                <a style={{display: 'flex', justifyContent: 'center'}}>Измените название категории</a>
                                <input type="text" placeholder='Введите название категории' value={categoryName} onChange={(e) => {setCategoryName(e.target.value)}} />
                                {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                                <button className='button maxWidth' type='submit'>Подтвердить изменение</button>
                            </span>
                        )}
                    </div>
                </form>
            </div>
        )
    }
    if (type == 'phase') {
        return (
            <div className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onClick={(e) => e.stopPropagation()} onSubmit={(e) => changeDataPhase(e)}>
                    <div className={styles.header}>
                        <h1>Изменить этап</h1>
                        <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                        </svg>
                    </div>
                    <div className={styles.main}>
                        {loading ? (
                            <Loading />
                        ) : warning ? (
                            <a>{warning}</a>
                        ) : (
                            <>
                                <a>Измените название этапа</a>
                                <input type="text" placeholder='Введите название этапа' value={phaseName} onChange={(e) => {setPhaseName(e.target.value)}} />
                                <a>Измените срок исполнения этапа в днях</a>
                                <input type="text" placeholder='Введите срок исполнения этапа' value={phaseTime} onChange={(e) => {setPhaseTime(e.target.value)}} />
                                <div className={styles.lineCheckBox}>
                                    <a>Отметьте, если срок отсчитывается только по рабочим дням</a>
                                    <input
                                        type="checkbox"
                                        checked={phaseTypeSch == '1'}
                                        onChange={(e) => {setPhaseTypeSch(e.target.checked ? '1' : '0')}}
                                    />
                                </div>
                                {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                                <button className='button maxWidth' type='submit'>Подтвердить изменение</button>
                            </>
                        )}
                    </div>
                </form>
            </div>
        )
    }

    return (
        <div className={styles.liningOver} onClick={closeModal}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Ошибка</h1>
                    <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    <a>Системе не удалось корректно обработать запрос. Обратитесь к администратору.</a>
                </div>
            </form>
        </div>
    );
}

export default ChangeLabelCategotyPhaseModal;